import { Routes } from '@angular/router';
import { BaseLayoutComponent } from './layouts/in-app-layout/base-layout.component';
import { FleetManagementComponent } from './pages/fleet-management/fleet-management.component';
import { SoftwareUpdatesComponent } from './pages/software-updates/software-updates.component';
import { DeployManagementComponent } from './pages/deploy-management/deploy-management.component';
import { LogManagementComponent } from './pages/log-management/log-management.component';
import { HomeComponent } from './pages/home/home.component';
import { SigninPageComponent } from './pages/signin-page/signin-page.component';
import { SignupPageComponent } from './pages/signup-page/signup-page.component';
import { PasswordResetComponent } from './modules/besharp-sessions/lib/components/password-reset/password-reset.component';
import { RegistrationSubmittedComponent } from './pages/registration-submitted/registration-submitted.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { AppConfigComponent } from './pages/app-config/app-config.component';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';
import { GlobalAdminGuard } from './guards/global-admin.guard';
import { RootRedirectGuard } from './guards/root-redirect.guard';

export const routes: Routes = [
  {
    path: 'app',
    title: 'Home',
    component: BaseLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', title: 'OTA Portal', component: HomeComponent },
      { path: 'fleet-management', title: 'Fleet Management', component: FleetManagementComponent },
      { path: 'software-updates', title: 'Software Updates', component: SoftwareUpdatesComponent },
      { path: 'deploy-management', title: 'Deploy Management', component: DeployManagementComponent },
      { path: 'log-management', title: 'Log Management', component: LogManagementComponent },
      { path: 'users', title: 'User Management', component: UserManagementComponent, canActivate: [AdminGuard] },
      { path: 'config', title: 'Application Settings', component: AppConfigComponent, canActivate: [GlobalAdminGuard] },
    ],
  },
  {
    path: 'signin',
    title: 'Sign In',
    component: SigninPageComponent,
  },
  {
    path: 'signup',
    title: 'Sign Up',
    component: SignupPageComponent,
  },
  {
    path: 'registration-submitted',
    title: 'Registration Submitted',
    component: RegistrationSubmittedComponent,
  },
  { 
    path: 'password-reset',
    title: 'Password Reset',
    component: PasswordResetComponent 
  },
  { path: '', canActivate: [RootRedirectGuard], children: [] },
  { path: '**', redirectTo: '/signin' }
];
